import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';
import { ValveViewModel } from 'src/app/shared/models/autogenerated-piping';

export interface ValveSelectionModalData {
  title: string;
  existingValveIds: string[];
}

@Component({
  selector: 'app-valve-selection-modal',
  templateUrl: './valve-selection-modal.component.html',
  styleUrls: ['./valve-selection-modal.component.scss'],
  standalone: false
})
export class ValveSelectionModalComponent implements OnInit {
  selectedValves: ValveViewModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<ValveSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ValveSelectionModalData,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Modal initialization
  }

  adjustTooltipPosition(tooltip: HTMLElement, parent: HTMLElement) {
    const tooltipRect = tooltip.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
  
    // Adjust if the tooltip overflows on the left
    if (tooltipRect.left < parentRect.left) {
      tooltip.style.left = '0';
      tooltip.style.transform = 'none';
    }
  
    // Adjust if the tooltip overflows on the right
    if (tooltipRect.right > parentRect.right) {
      tooltip.style.left = 'auto';
      tooltip.style.right = '0';
      tooltip.style.transform = 'none';
    }
  }

  onValvesSelected(valves: ValveViewModel[]): void {
    this.selectedValves = valves;
  }

  onRemoveValveClicked(valve: ValveViewModel): void {
    const idx = this.selectedValves.findIndex(v => v.id === valve.id);
    if (idx >= 0) {
      this.selectedValves.splice(idx, 1);
      (valve as any).__selected = false;
    }
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedValves);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
